import { isEqual, sortBy } from "lodash";

import { Stem, StemTextSelectable } from "@examspark/types";

import { getNewScore } from "./utils";

export const scoreTextSelectable = (
  expected: StemTextSelectable,
  actual: Partial<Stem.Response>,
) => {
  const score = getNewScore();
  score.max = 1;
  const { scoring } = expected;
  const keys: Array<string> = [];

  if (!actual?.options) {
    return score;
  }

  for (const k in scoring?.options) {
    const element = scoring.options?.[k];

    // We had a bug where keys would get left in scoring
    // after being removed from the question. Ensure that
    // we only check against keys that are possible to select.
    const elementExists = !!expected?.content?.options?.find(
      (option) => option.id === k,
    );

    if (elementExists && element?.isKey) {
      keys.push(k);
    }
  }

  // only supporting exact scoring for the time being
  if (isEqual(sortBy(keys), sortBy(actual.options))) {
    score.max = 1;
    score.actual = 1;
  }

  return score;
};
